/* eslint-disable no-undefined */
/* eslint-disable camelcase */
/* eslint-disable consistent-return */

export default class AutoComplete {
  constructor(autoCompleteConfig) {
    if (
      autoCompleteConfig === undefined ||
      autoCompleteConfig.elem === undefined
    ) {
      return;
    }

    this.autocomplete = undefined;
    this.updateOrgName = this.updateOrgName.bind(this);
    this.elem = autoCompleteConfig.elem;
    this.resultType = autoCompleteConfig.resultType;

    if (autoCompleteConfig.formMappings !== undefined) {
      this.formMapping = autoCompleteConfig.formMappings;
    } else {
      this.formMapping = {
        name: 'organizationName',
        street_number: 'organizationAddress',
        route: 'organizationAddress',
        locality: 'organizationCity',
        administrative_area_level_1: 'organizationState',
        postal_code: 'organizationPostalCode',
        phone: 'organizationPhone'
      };
    }

    this.componentForm = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'short_name',
      country: 'long_name',
      postal_code: 'short_name'
    };

    if (this.elem === undefined || this.elem === null) {
      return;
    }

    this.initialize();

    this.elem.addEventListener('keyup', () => {
      this.deleteAddress();
      return this.updateOrgName('input');
    });

    this.elem.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        return false;
      }
    });
  }

  initialize() {
    if (typeof google === 'object' && typeof google.maps === 'object') {
      const options = {
        componentRestrictions: { country: 'us' }
      };

      if (Array.isArray(this.resultType)) {
        options.types = this.resultType;
      } else if (typeof this.result === 'string') {
        options.types = [this.resultType];
      }

      this.autocomplete = new google.maps.places.Autocomplete(
        this.elem,
        options
      );

      this.autocomplete.addListener('place_changed', () => {
        window.setTimeout(() => this.fillInAddress(), 600);
      });
    }
  }

  deleteAddress() {
    return (() => {
      const result = [];
      for (let key in this.formMapping) {
        if (Object.prototype.hasOwnProperty.call(this.formMapping, key)) {
          const elementId = this.formMapping[key];
          let elem = document.querySelector(`#${elementId}`);
          result.push((elem.value = ''));
        }
      }
      return result;
    })();
  }

  updateOrgName(source, newName) {
    if (this.formMapping.name === undefined) {
      return null;
    }

    this.nameField = document.querySelector(`#${this.formMapping.name}`);

    const name = (() => {
      switch (source) {
        case 'fill':
          return newName;
        case 'input':
          return this.elem.value;
        default:
          return null;
      }
    })();

    return (this.nameField.value = name);
  }

  fillInAddressElement(elementId, value) {
    let elem = document.querySelector(`#${elementId}`);

    if (elem) {
      const prevVal = elem.value;
      const newVal = prevVal ? `${prevVal} ${value}` : value;
      elem.value = newVal;
    }
  }

  fillInAddress() {
    if (typeof this.autocomplete != 'object') {
      return;
    }

    const place = this.autocomplete.getPlace();
    this.deleteAddress();
    this.updateOrgName();

    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        this.fillInAddressElement(
          this.formMapping[addressType],
          place.address_components[i][this.componentForm[addressType]]
        );
      }
    }

    this.fillInAddressElement(
      this.formMapping.phone,
      place.formatted_phone_number
    );
    this.updateOrgName('fill', place.name);
  }
}
